import { InjectionToken } from '@angular/core';

export const NIKO_API_URL = new InjectionToken<string>('NIKO_API_URL');
